<template>
	<div>
		<div class="white">
			<v-row class="ma-0" align="center">
				<!-- breadcrumbs -->
				<v-col lg="auto" md="12" cols="auto" class="d-flex flex-column pe-0">
					<slot name="breadcrumbs" :item="true" class="journal-breadcrumbs"></slot>
				</v-col>
				<v-col
					md="auto"
					cols="auto"
					class="d-flex align-center justify-start pe-0"
				>
					<span class="px-2">{{ $t('AccountingJournalPage.coming-from') }}:</span>
					<v-btn-toggle>
						<v-btn
							small
							color="white"
							:disabled="!simplified_bonds.filter(c => !c.invoice_id).length"
							:class="[
								{'info-dark-color white--text': +$route.query.type === 2},
								`rounded-${$i18n.locale !== 'ar' ? 'r' : 'l'}-0`
							]"
							@click="$router.replace({
								name: $route.name,
								params: { id: simplified_bonds.filter(c => !c.invoice_id)[simplified_bonds.filter(c => !c.invoice_id).length - 1]?.id ?? 0 },
								query: activeJournals !== 2 ? { type: 2 } : {}
							})"
						>
							<span class="px-2">{{ $t('AccountingJournalPage.journals-by-default') }}</span>
						</v-btn>
						<v-btn
							small
							color="white"
							:disabled="!simplified_bonds.filter(c => c.invoice_id).length"
							:class="[
								{'info-dark-color white--text': +$route.query.type === 1},
								`rounded-0`
							]"
							@click="$router.replace({
								name: $route.name,
								params: { id: simplified_bonds.filter(c => c.invoice_id)[simplified_bonds.filter(c => c.invoice_id).length - 1]?.id ?? 0 },
								query: activeJournals !== 1 ? { type: 1 } : {}
							})"
						>
							<span class="px-2">{{ $t('AccountingJournalPage.journals-by-invoice') }}</span>
						</v-btn>
						<v-btn
							small
							color="white"
							:disabled="!simplified_bonds.filter(c => c.invoice_id).length"
							:class="[
								{'info-dark-color white--text': !$route.query.type},
								`rounded-${$i18n.locale !== 'ar' ? 'l' : 'r'}-0`
							]"
							@click="$router.replace({
								name: $route.name,
								params: { id: simplified_bonds[simplified_bonds.length - 1]?.id ?? 0 },
								query: activeJournals ? { type: null } : {}
							})"
						>
							<span class="px-2">{{$t('all')}}</span>
						</v-btn>
					</v-btn-toggle>
				</v-col>
				<!-- bond No (next/prev) -->
				<v-col
					md="auto"
					cols="auto"
					style="width: auto !important;"
					class="d-flex align-center justify-start"
				>
					<bee-bond-up-down
						v-model="bond_no"
						:label="$t('AccountingJournalPage.bond-no')"
						:items="filterJournals.map(c=>c.bond_no)"
						:disabled="loading || !simplified_bonds.length"
						class="medium-placeholder"
						@keydown-enter-prevent="fetchBond()"
						@programmatically-changed="fetchBond()"
					></bee-bond-up-down>
				</v-col>
				<v-col class="d-flex align-center" cols="auto">
					<!-- create bond -->
					<bee-btn
						:content="$t('AccountingJournalPage.new')"
						context="bond"
						color="addingColor"
						icon="fa-plus"
						:disabled="file_is_locked || loading"
						@click="create_bonds_manually ? addBondDialog = true : addBond()"
						:action-name="actions.CREATE"
					></bee-btn>
					<!--delete bond-->
					<bee-btn
						v-if="!bond.invoice_id && !file_is_locked && !bond.is_posted && bond.id && !hideDeleteButton"
						context="account"
						:action-name="actions.DELETE"
						:content="$t('AccountingJournalPage.delete')"
						icon="fa-trash-alt"
						color="deletingColor"
						:disabled="loading"
						outer-class="ms-4"
						@click="deleteDialog = true"
						:loading="deleteLoading"
					/>
				</v-col>
				<v-col ></v-col>
				<v-col v-if="true" sm="auto" xs="12" cols="auto" class="d-flex align-center px-3">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attr }">
							<div
								class="d-flex align-center"
								v-on="on"
								v-bind="attr"

							>
								<!-- <v-switch
									v-if="false"
									dense
									hide-details
									inset
									label="الحساب العكسي"
									>
								</v-switch> -->
								<v-btn
									class=" rounded-lg pa-0 greyDarken2--text"
									text
									style="border:2px solid rgb(230,200,20)"
									@click="reverseCurrency(!reverseCurrencyPrice)"
								>
									<div
										class="rounded-lg"
										style="background:rgb(230,200,20); padding: 6px 0"
										:class="`rounded-${$i18n.locale !== 'ar' ? 'r' : 'l'}-0`"
									>
										<v-icon
											class="rounded-lg mx-2"
											color="white"
										>
											mdi-swap-vertical
										</v-icon>
									</div>
									<div
										class="d-flex flex-column align-center justify-center relative  mx-3 rounded-lg"
										:class="`rounded-${$i18n.locale !== 'ar' ? 'l' : 'r'}-0`"
									>
										<span class="absolute fw-bold" style='top:-50%; left:-20%;'>
											<v-icon class="mb-1 ms-2" v-if="reverseCurrencyPrice" size="8px">
												fa-money-bill-wave
											</v-icon>
											<v-icon  v-else size="10px">
												fa-coins
											</v-icon>
										</span>
										<span class="absolute" style='top:30%; left:70%;' >
											<v-icon v-if="!reverseCurrencyPrice" size="8px">
												fa-money-bill-wave
											</v-icon>
											<v-icon v-else size="10px">
												fa-coins
											</v-icon>
										</span>
										<v-icon class="" small>
											mdi-slash-forward
										</v-icon>
									</div>
								</v-btn>
							</div>
						</template>
						<span>{{$t('AccountingJournalPage.reverse-currency-price')}}</span>
					</v-tooltip>
				</v-col>
				<!-- create account button -->
				<v-col v-if="userType !== userPermission.treasurer" sm="auto" xs="12" cols="auto" class="d-flex align-center">
					<bee-btn
						context="account"
						:action-name="actions.CREATE"
						@click="createAccount()"
						:disabled="file_is_locked"
						color="addingColor"
						:content="$t('AccountingJournalPage.add')"
						icon="fa-user-plus"
					></bee-btn>
				</v-col>
			</v-row>
			<v-row class="ma-0">
				<v-col cols="auto" lg="auto" sm="12" md="auto" class="flex-grow-1 d-flex pt-0 ps-lg-0">
					<v-layout wrap class="d-flex flex-row my-border rounded-lg">
						<!-- invoice buttons toggle -->

						<v-col cols="auto" class="d-flex align-center">
							<bee-date-picker
								v-model="bondData.date"
								ref="dateEdit"
								:disabled="bond.is_posted || file_is_locked || loading"
								context="invoice"
								:action-name="actions.EDIT"
								:label="$t('inputs.bond-date')"
								:rules="[
									rules.date,
									canAddFutureDate 
										? true
										: v => moment(v).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') || false
								]"
								:hide-details="true"
								@blur="updateBond()"
							></bee-date-picker>
						</v-col>
						<v-col v-if="useBondNotes" cols="12" sm="4" md="3" lg="3" class="d-flex align-center">
							<v-text-field 
							class="mx-3"
							v-model="bondData.notes"
							:disabled="this.bond?.is_posted || loading"
							:label="$t('inputs.notes')"
							outlined
							dense
							hide-details
							@change="updateBond()"
							/>
						</v-col>
						<v-spacer></v-spacer>
						<!-- create & save/edit bond -->
						<v-col cols="auto" sm="auto" xs="12" md="auto" lg="auto" class="d-flex align-center">
							<!-- (save/edit) bond | show bill  -->
							<bee-btn
								v-if="
									useUnPostingPermission
										? (!bond.is_posted || (bond.is_posted && canUnPost))
										: true
								"
								:icon="
									bond.is_posted
										? (bond.invoice_id 
											? userType === userPermission.treasurer 
												? '' 
												: 'far fa-share-square' 
											: 'fa-envelope-open') 
										: 'fa-envelope'
								"
								:outer-class="on_lgAndUp ? 'text-wrap' : ''" 
								:content="on_lgAndUp ?
										bond.is_posted 
											? bond.invoice_id 
												? userType === userPermission.treasurer 
													? $t('AccountingJournalPage.created-from-invoice') 
													: $t('AccountingJournalPage.view-invoice') 
												: $t('AccountingJournalPage.edit') 
											: $t('AccountingJournalPage.save')
										: ''
								"
								:disabled="file_is_locked && !bond.invoice_id || (loading && !updateBondLoading)"
								:color="bond.is_posted ? 'deletingColor' : 'blueGray'"
								@click="bond.is_posted 
									? ( bond.invoice_id 
										? userType === userPermission.treasurer 
											? null 
											: reForwardToRelatedInvoice() 
										: unPosting()) 
									: posting()
								"
								:loading="updateBondLoading"
								context="bond"
								:action-name="actions.EDIT"
							></bee-btn>
						</v-col>

						<!-- <v-spacer v-if="on_mdAndUp"></v-spacer> -->
						

						<!-- <v-spacer v-if="on_mdAndUp"></v-spacer> -->

						<v-col v-if="useBondAuditLogs" cols="auto" class="d-flex align-center px-0">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attr }">
									<v-btn
										small
										depressed
										color="transparent"
										:disabled="loading"
										@click="infoDialog = true"
										v-on="on"
										v-bind="attr"
									>
									<v-icon>mdi-information-outline</v-icon>
									</v-btn>
								</template>
								<span>{{ $t('invoice-info') }}</span>
							</v-tooltip>
						</v-col>

						<!-- bond posting progress circular -->
						<v-col cols="auto" class="d-flex justify-lg-end py-1">
							<router-link style="text-decoration: none;" :to="{name: 'journals'}">
								<bee-progress-circular
									:size="60"
									:width="6"
									:title="bond_posting_ratio_caption"
									:value="bond_posting_ratio"
									:tooltip="bond_posting_ratio_tooltip"
									class="text-caption"
								></bee-progress-circular>
							</router-link>
						</v-col>

						<!-- posted / not posted -->
						<v-col
							lg="1"
							sm="12"
							xs="12"
							:cols="on_mdAndUp ? 'auto': '12'"
							:class="[
								bond.is_posted ? 'postedColor' : 'unpostedColor',
								on_lgAndUp ? 'border-round-end' : 'border-round-bottom'
							]"
							:style="on_lgAndUp ? 'height: 100%; ' : ''"
							style="border-color: transparent !important;  align-items: center !important;"
							class="justify-content-center justify-center flex-grow-1 d-flex white--text my-border text--title text-center align-center font-weight-bold text-wrap"
						>
							<span class="text-center align-center" style="line-height: 1.2;">
								{{bond.is_posted ? '' : $t('AccountingJournalPage.not')}}
								<br v-if="!bond.is_posted" />
								{{$t('AccountingJournalPage.posted')}}
							</span>
						</v-col>
					</v-layout>
				</v-col>
			</v-row>
		</div>

		<div>
			<!-- table -->

			<!-- 
				hide-shown-rows-text="auto"
				:shown-rows-text="$t('shown-rows-text')"
			-->
			<v-card flat>
				<v-card-text class="py-0 px-3">
					<bee-handy-smart-table
						ref="table"
						v-model="tableInputs"
						:headers="headers"
						:items="entries"
						:items-per-page="10"
						hot-inputs="lazy"
						:hot-inputs-order="['currency-price']"
						dense
						zebra
						fixed-header
						pagination-on-scroll
						stay-in-input-fields
						:data-table-props="{
							disableSort: true
						}"
						:shown-rows-text="$t('shown-rows-text')"
						:height="$vuetify.breakpoint.height - 350"
						hide-no-data-area
						hide-inputs-details="auto"
						with-columns-divider
						:show-add-row="!bond.is_posted && !file_is_locked && !updateBondLoading && !isViewer && Boolean($route.params.id)"
						:editable-rows="!bond.is_posted && !file_is_locked && !updateBondLoading && !isViewer"
						:context-menu-items="contextmenuItems"
						:loading="loading"
						:disable-input-fields="loading"
						:disable-context-menu="loading || isViewer"
						disable-mobile-context-menu
						:row-highlight-expression="(item) => item.id === Number($route.query.entryId)"
						:scroll-to-row-expression="(item) => item.id === entryId || item.id === entries[entries.length - 1].id"
						:validation-messages.sync="validationMessages"
						@context-menu-account-statement="openAccountStatement"
						@context-menu-edit="({ item }) => {entryId = item.id; this.reverseCurrencyPriceInputValue()}"
						@context-menu-delete="({ item }) => { deleteEntryId = item.id; dialogDeleteAccountingEntry = true}"
						@edit-cancelled="
							entryId = null; 
						"
						@keypress.enter="entryHandler"
						@keydown.tab="inputsNavigationHandler"
						@reached-last-input="entryHandler"
						@change-currency="tableInputs['currency-price'] = getCurrencyById(tableInputs.currency)?.latest_exchange_record 
						? (reverseCurrencyPrice 
									? 1 / getCurrencyById(tableInputs.currency)?.latest_exchange_record 
									: getCurrencyById(tableInputs.currency)?.latest_exchange_record
							) 
						: null" 
						@dblclick:row="(e, { item }) => { 
							bond.is_posted && userType !== userPermission.treasurer ? openAccountStatement({ item }) : null
						}"
					>
						<!-- account -->
						<template v-slot:input.account="{ on, attr }">
							<v-autocomplete
								v-on="on"
								v-bind="attr"
								:items="configs.accounts.filter(c => c.type === 2)"
								item-value="id"
								:item-text="item => item.accounting_no + '-'+ item.name"
								auto-select-first
							>
								<template v-slot:selection="{ item }">
									{{ item.accounting_no +'-'+ item.name }}
								</template>
								<template v-slot:item="{ item }">
									{{ item.accounting_no + '-'+ item.name }}
									<v-spacer></v-spacer>
									<bee-advanced-money-label
										v-if="userType !== userPermission.treasurer"
										:with-color="true"
										:value="item?.account_statement_summary"
										:show-zeros-values="true"
									></bee-advanced-money-label>
								</template>
							</v-autocomplete>
						</template>

						<!-- currency -->
						<template v-slot:input.currency="{ on, attr }">
							<v-autocomplete
								v-on="on"
								v-bind="attr"
								:items="[{ id: null, symbol: null }, ...configs.currencies.filter(v => v.id !== currentFinancialFile?.default_currency_id)
								]"
								item-value="id"
								item-text="symbol"
							>
								<template v-slot:item="{ item }">
									{{item.id ? item.symbol : $t('inputs.undefined')}}
								</template>
							</v-autocomplete>
						</template>

						<!-- order inside bond -->
						<template v-slot:no-input.order-inside-bond="{ item }">
							<span class="font-weight-bold">{{item ? item.order_inside_bond : null}}</span>
						</template>

						<!-- date -->
						<!-- FIXME replace `bee-date-field` with `bee-date-input` -->
						<template v-if="showDateEntryColumn"  v-slot:input.date="{ on, attr }">
							<bee-date-field
								v-on="on"
								v-bind="attr"
								dense
							></bee-date-field>
						</template>

						<!-- hint -->
						<template v-slot:no-input.hint>
							<v-menu  bottom v-if="validationMessages.length > 0">
								<template v-slot:activator="{ on, attr }">
									<v-icon
										v-on="on"
										v-bind="attr"
										color="danger-color"
										size="20"
									>mdi-information</v-icon>
								</template>

								<v-list>
									<v-list-item
										v-for="(message, i) in inputsValidationMessages"
										:key="i"
										dense
										class="px-2"
									>
										<v-list-item-icon class="me-0 mb-0">
											<v-icon color="danger-color" x-small>mdi-circle-half</v-icon>
										</v-list-item-icon>
										<v-list-item-title class="danger-color--text">
											{{message}}
										</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
							<!-- focus handler to avoid focusing out side the page-->
							<v-btn v-else text plain retain-focus-on-click min-width="1px" height="1px" class="pa-0" 	@keydown.tab.prevent>
							</v-btn>
						</template>

						<!-- options -->
						<template v-slot:item.hint="{ item, index }">
							<div class="text-center">
								<v-menu offset-y>
									<template v-slot:activator="{ on, attr }">
										<v-btn
											small
											icon
											v-bind="attr"
											v-on="on"
											width="32"
										>
											<v-icon>
												mdi-dots-vertical
											</v-icon>
										</v-btn>
									</template>
									<v-list dense>
										<v-list-item v-if="userType !== userPermission.treasurer" @click="openAccountStatement({ item })">
											<v-list-item-content class="pa-0">
												{{ $t('AccountingJournalPage.context-menu.account-statement') }}
											</v-list-item-content>
										</v-list-item>
										<v-list-item 
											@click="$refs.table.activeEditForRow(index); entryId = item.id; reverseCurrencyPriceInputValue()"
											
											:disabled="bond.is_posted || file_is_locked"
										>
											<v-list-item-content class="pa-0">
												{{ $t('AccountingJournalPage.context-menu.edit') }}
											</v-list-item-content>
										</v-list-item>
										<v-list-item 
											@click="deleteEntryId = item.id; dialogDeleteAccountingEntry = true"
											:disabled="bond.is_posted || file_is_locked"
										>
											<v-list-item-content class="pa-0">
												{{ $t('AccountingJournalPage.context-menu.delete') }}
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
							</div>
						</template>
					</bee-handy-smart-table>
				</v-card-text>
			</v-card>

			<!-- dialog delete Accounting -->
			<bee-dialog
				v-model="dialogDeleteAccountingEntry"
				:title="$t('AccountingJournalPage.delete-account-entry')"
				:message="$t('AccountingJournalPage.are-you-sure-you-want-to-delete-the-entry')"
				@handler="confirmDeleteEntry()"
				@close="dialogDeleteAccountingEntry = false; deleteEntryId = null"
			></bee-dialog>
			<!--dialog delete bond-->
			<v-dialog v-model="deleteDialog" width="450px">
				<v-card>
					<v-card-title>
						{{$t('bonds.delete-bond')}}
					</v-card-title>
					
					<v-card-text class="py-2">
						{{$t('bonds.delete-bond-confirm')}}
					</v-card-text>
	
					<v-card-actions>
						<v-btn text color="success-color" @click="[deleteDialog = false,DeleteBond()]">{{$t('buttons.ok')}}</v-btn>
						<v-btn text color="danger-dark-color" @click="deleteDialog = false">
							{{$t('buttons.cancel')}}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!-- creat bond dialog -->
			<v-dialog transition="dialog-top-transition" v-model="addBondDialog" max-width="500">
				<v-form ref="bondForm" v-model="valid" @submit.prevent="addBond()">
					<v-card>
						<v-card-title class="headline">
							{{$t('AccountingJournalPage.add-bond')}}
						</v-card-title>
						<v-card-text>
							<bee-date-picker
								v-model="bond_date"
								context="bond"
								:action-name="actions.CREATE"
								:label="$t('AccountingJournalPage.bond-date')"
								:rules="[
									rules.date,
									canAddFutureDate 
										? true 
										: v => moment(v).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') || false
								]"
							></bee-date-picker>
							<v-text-field 
								v-model="bond_notes"
								class="mx-3"
								:label="$t('inputs.notes')"
								outlined
								dense
								hide-details
							/>
						</v-card-text>
						<v-card-actions class="mr-3">
							<v-btn
								type="submit"
								color="greenDarken1"
								text
								:loading="loading"
								:disabled="!valid"
							>
								{{$t('AccountingJournalPage.create')}}
							</v-btn>
							<v-btn color="redDarken1" text @click="addBondDialog = false">
								{{$t('AccountingJournalPage.cancel')}}
							</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-form>
			</v-dialog>
			
			<!-- creata account dialog -->
			<account-form v-model="showAccountForm"></account-form>

			<!-- the code of the info dialog goes here -->
			<v-dialog
				v-model="infoDialog"
				max-width="550"
				content-class="rounded-xl"
				persistent
			>
				<v-card
					class="rounded-xl"
				>
					<v-card-title class="rounded-xl">{{ $t('invoice-info') }}</v-card-title>
					<v-card-text class="pb-1">
						<bee-handy-table
							:headers="infoHeaders"
							:items="accountingBond.audit_log_simplified_responses ? accountingBond.audit_log_simplified_responses : [] "
							dense
							pagination-on-scroll
							shown-rows-text=""
							fixed-header
							elevation="1"
							zebra
						>
							<template v-slot:item.type="{ item }">
								<span  
								    :class="
										item.type === actionType.create ? 'green--text'
										: item.type === actionType.post ? 'blue--text' 
										: item.type === actionType.unPost ? 'warning--text' 
										: null"
								>
									{{ actionTypes.find(c => c.type === item.type)?.name }}
									<!-- {{
										actionTypes
											.slice()
											.sort((a, b) => new Date(a.date) - new Date(b.date))
											.find(c => c.type === item.type)?.name
									}} -->
								</span>
							</template>
							<template v-slot:item.date="{ item }">
								<div dir="auto" class="d-flex justify-end">
									{{ moment(item.date_formatted).locale('en').format('h:mm:ss A ,YYYY-MM-DD') }}
								</div>
							</template>
						</bee-handy-table>
					</v-card-text>
					<v-card-actions class="rounded-xl">
							<v-btn 
							color="transparent grey--text"
							smal
							depressed
							@click="infoDialog = false"
							>
							<span>{{ $t('close') }}</span>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</div>

		<!-- footer -->
		<v-footer id="footer" fixed app horizontal background-color="#E1E1E1" class="px-2">
			<div class="d-flex justify-space-between py-3" style="width: 100%;">
				<v-row class="d-flex justify-space-between">
					<v-col cols="12" sm="4" lg="auto">
						<div class="d-flex">
							<span class="text-caption">{{$t('AccountingJournalPage.footer.total')}}</span>
							<div class="d-flex justify-center mr-2">
								<v-card
								  class="d-flex align-center custom_debit_credit_styles">
									
									<v-card-text 
										:class="advancedColorMode ? 'red--text' : 'green--text'"
										class="pa-0 font-weight-bold d-flex justify-center"
										>
										{{ sum_debits ? sum_debits.amount.toLocaleString('en') : '' }}
									</v-card-text>
								</v-card>
								<v-card
								  class="d-flex align-center custom_debit_credit_styles">
									<v-card-text 
										:class="advancedColorMode ? 'green--text' : 'red--text'"
										class="pa-2 font-weight-bold d-flex justify-center"
										>
										{{ sum_credits ? sum_credits.amount.toLocaleString('en') : '' }}
									</v-card-text>
								</v-card>
								<v-card
								  :width="60"
								  class="d-flex justify-center align-center mr-3 text-body-2">
									{{ sum_difference ? getCurrencyById(sum_difference.currency_id).symbol : '' }}
								</v-card>
							</div>
						</div>
						<div class="d-flex justify-center mt-2">
							<span class="text-caption">{{$t('AccountingJournalPage.footer.difference')}}</span>
							<div class="d-flex justify-center mr-6">
								<v-card
								  class="d-flex align-center custom_sum_difference_styles">
									<v-card-text
										:class="[ sum_difference ? (sum_difference.money_type === (advancedColorMode ? 1 : 0) ? 'red--text' : 'green--text') : '' ]"
										class="pa-2 font-weight-bold text-center">
										{{ sum_difference ? sum_difference.amount.toLocaleString('en') : '' }}
									</v-card-text>
								</v-card>
								<v-card
								  :width="60"
								  class="d-flex justify-center align-center mr-3 text-body-2">
								  {{ sum_difference ? getCurrencyById(sum_difference.currency_id).symbol : '' }}
								</v-card>
							</div>
						</div>
	
					</v-col>
					<v-col
					  cols="12"
					  sm="4"
					  lg="auto"
					  class="d-flex align-center">
					</v-col>
					<v-spacer></v-spacer>
					<v-col cols="12" sm="4" lg="auto">
						<div class="d-flex justify-space-between my-auto">
							<div class="d-flex mr-12">
								<v-card class="custom_currency_debits_credits_styles d-flex align-center">
									<v-card-text class="pa-1 d-flex justify-center">
										<div class="d-flex flex-column">
											<span
												v-for="(item, index) in currency_debits"
												:key="index"
												class="red--text"
											>
												{{ item.amount.toLocaleString('en') }}
												{{ getCurrencyById(item.currency_id).symbol }}
											</span>
										</div>
									</v-card-text>
								</v-card>
								<v-card class="custom_currency_debits_credits_styles d-flex align-center">
									<v-card-text class="pa-1 d-flex justify-center">
										<div class="d-flex flex-column">
											<span
												v-for="(item, index) in currency_credits"
												:key="index"
												class="green--text"
											>
												{{ item.amount.toLocaleString('en') }}
												{{ getCurrencyById(item.currency_id).symbol }}
											</span>
										</div>
									</v-card-text>
								</v-card>
							</div>
						</div>
					</v-col>
					<v-col cols="12" lg="auto" class="px-1">
						<div>
							<v-card class="custom_currency_sum_styles d-flex align-center">
								<v-card-text class="pa-1 d-flex justify-center">
									<div class="d-flex flex-column">
										<span
											v-for="(item, index) in currencies_sum_difference"
											:key="index"
											:class="[item ? (item.money_type === 1 ? 'red--text' : 'green--text') : '']"
										>
											{{ item.amount.toLocaleString('en') }}
											{{ getCurrencyById(item.currency_id).symbol }}
										</span>
									</div>
								</v-card-text>
							</v-card>
						</div>
					</v-col>
					<v-col
						v-if="show_symbol_currencies && on_mdAndUp"
						cols="12" 
						sm="4" 
						lg="1"
						class="px-0 d-flex justify-lg-end justify-md-end justify-center align-center mr-12"
					>
					</v-col>
				</v-row>
			</div>
		</v-footer>
	</div>
</template>
<script>
import AccountForm from './sub-components/AccountForm.vue';
import store from '../../../store/index.js';
import ls from '../../../settings/localStorageExtension';
import EventBus from '../../../event-bus'
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import actions from '../../../permissions/actions-names.js';
import rules from '../../../validation';
import { bondType, actionTypes, actionType, userPermission } from '@/helpers/enums';
import { useUnPostingPermission, useBondAuditLogs, useBondNotes } from '@/configs/global';
import moment from 'moment'

const openNewWindowForAccountStatement =
	JSON.parse(localStorage.getItem('openAccountStatementInNewWindow'));

export default {
	components: { AccountForm },

	data: () => ({
		dialogDeleteAccountingEntry: false,
		actions,
		sum_difference_equivalent: {
			amount: null,
			currency_id: null,
			money_type: null
		},
		showAccountForm: false,
		showExchangeForm: false,
		externalRequest: false,
		restLastRow: false,
		bond_no: null,
		...rules,
		addBondDialog: false,
		loading: false,
		bond_date: moment().format('YYYY-MM-DD'),
		linkedBoundRules: {
			debit: true,
			credit: true,
			currency_debit: true,
			currency_credit: true,
			currency_id: true
		},
		useBondAuditLogs,
		useBondNotes,
		// helpers
		updateBondLoading: false,
		deleteEntryId: null,
		entryId: null,
		saveNotes: null,
		tableInputs: {},
		validationMessages: [],
		deleteLoading: false,
		useUnPostingPermission,
		deleteDialog :false,
		show: false,

		infoDialog: false,
		actionTypes,
		actionType,
		userPermission,
		moment,

		reverseDivider: false,
		bondData: {
			type: bondType.accounting,
			notes: null,
			date: null
		},
		bond_notes: null,
		valid : true,
		reverseCurrencyPrice: false
	}),

	watch: {
		// $route: function(to, from) {
		$route: function(to, from) {
			this.$refs.table.resetEdit();
			this.sum_difference_equivalent = {
				amount: null,
				currency_id: null,
				money_type: null
			};
			// || (from.name == "accounting-journal" && to.name == "accounting-journals")
			if (
				!to.params.id ||
				to.params.id != this.simplified_bonds?.find(c => c.bond_no == this.bond_no)?.id
			) {
				if (to.params.id) {
					// const bondId = this.simplified_bonds[this.simplified_bonds.length - 1].id
					const bondId = to.params.id;
					this.loading = true;
					store
						.dispatch("bonds/fetch", {
							bondId: bondId,
							bondType: bondType.accounting
						})
						.then(response => {
							if (!to.params.id) {
								this.$router.replace({ name: this.$route.name, params: { id: bondId }, query: from.query })
							}
							this.bond_no = response.bond_no;
							this.bondData.date = response.date;
							this.bondData.notes = response.notes;
							this.loading = false;
							this.tableInputs.note = response.entries[response.entries.length ? response.entries.length - 1 : 0 ].note
						});
				} else if (from.params.id && this.simplified_bonds.find(v => v.id === +from.params.id) ) {
					this.$router.push({name: 'accounting-journal', params: {id: from.params.id}});
				}
				else{
					this.$router.go(0);
				}
			}
		},

		'tableInputs.note'(newVal) {
			if (!this.entryId) {
				this.saveNotes = newVal;
			}
		},
		'tableInputs.date'(val) {
			if(!val) {
				this.tableInputs.date = moment(this.bondData.date).format('YYYY-MM-DD');
			}
		},
		'defaultReversedCurrencyPrice'(val) {
			this.reverseCurrencyPrice = val;
		}
	},

	computed: {
		// table headers
		headers0(){
			const headers = [
				{
					text: this.$t('AccountingJournalPage.headers.sequence'),
					name: 'order-inside-bond',
					value: 'order_inside_bond',
					width: '5%',
					noInput: true
				},
				{
					text: this.$t('AccountingJournalPage.headers.debit'),
					name: 'debit',
					value: 'debit.amount',
					type: 'number-format',
					width: '8%',
					inputRules: !this.tableInputs.credit ? [this.rules.required] : [],
					setInputExpr: (inputs, activeInput) =>
						inputs.debit > 0 && activeInput === 'credit' && inputs.credit > 0 ? 0 : inputs.debit,
				},
				{
					text: this.$t('AccountingJournalPage.headers.credit'),
					name: 'credit',
					value: 'credit.amount',
					type: 'number-format',
					width: '8%',
					inputRules: !this.tableInputs.debit ? [this.rules.required] : [],
					setInputExpr: (inputs, activeInput) =>
						inputs.credit > 0 && activeInput === 'debit' && inputs.debit > 0 ? 0 : inputs.credit,
				},
				{
					text: this.$t('AccountingJournalPage.headers.account'),
					value: 'account_id',
					name: 'account',
					width: '20%',
					setValueExpr: (value) => {
						const account = this.getAccountById(value) || {};
						return `${account.accounting_no}-${account.name}`
					},
					inputRules: [this.rules.required]
				},
				{
					text: this.$t('AccountingJournalPage.headers.note'),
					name: 'note',
					value: 'note',
					width: '20%',
				},
				{
					text: this.$t('AccountingJournalPage.headers.currency'),
					name: 'currency',
					value: 'currency_id',
					width: 90,
					setValueExpr: (value) => (this.getCurrencyById(value) || {}).symbol,
				},
				{
					text: this.$t('AccountingJournalPage.headers.currency-debit'),
					name: 'currency-debit',
					value: 'currency_debit.amount',
					type: 'number-format',
					width: this.$emerald.ifLang('es', '15%', '6%'),
					inputRules:
						this.tableInputs.currency && !this.tableInputs['currency-credit']
							? [this.rules.required]
							: [],
					setInputExpr: (inputs, activeInput) => {
						if ((activeInput === 'currency-credit' && inputs['currency-debit'] > 0) || !inputs.currency) {
							return 0;
						} else if (activeInput === 'currency-debit') {
							if (inputs.currency) {
								this.tableInputs.debit = inputs['currency-price'] * inputs['currency-debit'];
								if (this.tableInputs.credit) this.tableInputs.credit = null;
							}
							return inputs['currency-debit'];
						} else {
							return inputs.currency ? inputs.debit / (inputs['currency-price'] || 1) : null;
						}
					}
				},
				{
					text: this.$t('AccountingJournalPage.headers.currency-credit'),
					name: 'currency-credit',
					value: 'currency_credit.amount',
					type: 'number-format',
					width: this.$emerald.ifLang('es', '15%', '6%'),
					inputRules:
						this.tableInputs.currency && !this.tableInputs['currency-debit']
							? [this.rules.required]
							: [],
					setInputExpr: (inputs, activeInput) => {
						if ((activeInput === 'currency-debit' && inputs['currency-credit'] > 0) || !inputs.currency) {
							return 0;
						} else if (activeInput === 'currency-credit') {
							if (inputs.currency) {
								this.tableInputs.credit = inputs['currency-price'] * inputs['currency-credit'];
								if (this.tableInputs.debit) this.tableInputs.debit = null;
							}
							return inputs['currency-credit'];
						} else {
							return inputs.currency ? inputs.credit / (inputs['currency-price'] || 1) : null;
						}
					}
				},
				{
					text: this.$t('AccountingJournalPage.headers.price'),
					name: 'currency-price',
					value: 'currency_price',
					width: '8%',
					type: 'number-format',
					settings: { itemText: 'equivalentPrice', context: 'entry', actionName: this.actions.GET },
					inputRules: this.tableInputs.currency ? [this.rules.required] : [],
					setInputExpr: (inputs, activeInput) => {
						if (!inputs.currency) {
							return 0;
						} else if (activeInput === 'currency-price' || inputs['currency-price']) {
							return inputs['currency-price'];
						} else {
							return this.getCurrencyById(inputs.currency)?.latest_exchange_record;
						}
					}
				},
				{
					text: this.$t('AccountingJournalPage.headers.paper-document-no'),
					name: 'paper-document-no',
					value: 'paper_document_no',
					width: '5%',
				},
				{
					text: this.$t('AccountingJournalPage.headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					dateFormat: 'DD-MM-YYYY',
					width: 140,
					inputRules: [this.rules.required]
				},
				{
					text: '',
					name: 'hint',
					value: 'hint',
					width: 30,
					columnClass: 'px-0',
					noNotAvailableText: true,
					divider: false,
					noInput: true, 
				},
			];

			const commonClass = 'font-weight-bold px-2 grey--text text--darken-4';
			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass =
					headers[i].columnClass ? headers[i] + ' ' + commonClass : commonClass;
				headers[i].align = 'center';
			}

			return headers
		},
		headers(){
			let headers = [
				{
					text: '#',
					name: 'order-inside-bond',
					value: 'order_inside_bond',
					// width: '5%'
					width: '2%',
					noInput: true
				},
				{
					text: this.$t('AccountingJournalPage.headers.debit'),
					name: 'debit',
					value: 'debit.amount',
					type: 'number-format',
					// width: '8%'
					width: '9%',
					inputRules: (() => {
						if (this.inputsValidations.debit) return [];
						else return [() => false];
					})(),
				},
				{
					text: this.$t('AccountingJournalPage.headers.credit'),
					name: 'credit',
					value: 'credit.amount',
					type: 'number-format',
					// width: '8%'
					width: '9%',
					inputRules: (() => {
						if (this.inputsValidations.credit) return [];
						else return [() => false];
					})(),
				},
				{
					text: this.$t('AccountingJournalPage.headers.account'),
					value: 'account_id',
					name: 'account',
					width: '16%',
					inputRules: [this.rules.required],
					setValueExpr: val => {
						const account = this.getAccountById(val);
						return `${account.accounting_no}-${account.name}`
					}
				},
				{
					text: this.$t('AccountingJournalPage.headers.note'),
					name: 'note',
					type:'string',
					value: 'note',
					width: '17%',
				},
				{
					text: this.$t('AccountingJournalPage.headers.currency'),
					name: 'currency',
					value: 'currency_id',
					// width: 100
					width: 110,
					setValueExpr: (value) => (this.getCurrencyById(value) || {}).symbol,
				},
				{
					text: this.$t('AccountingJournalPage.headers.currency-debit'),
					name: 'currency-debit',
					value: 'currency_debit.amount',
					type: 'number-format',
					// 	width: this.$emerald.ifLang('es', '15%', '6%'),
					width: this.$emerald.ifLang('es', '15%', '7%'),
					inputRules: (() => {
						if (this.inputsValidations['currency-debit']) return [];
						else return [() => false]
					})(),
					setInputExpr: (inputs, activeInput) => {
						let price = this.reverseCurrencyPrice
										? (inputs['currency-price'] ? 1 / (inputs['currency-price']) : 0) 
										: inputs['currency-price'];
						if (activeInput !== 'currency-debit') {
							if (inputs.currency > 0 && inputs.debit && price) {
								this.tableInputs['currency-debit'] = inputs.debit / (price);
							}
							else if (inputs['currency-debit'] && inputs['credit']) {
								this.tableInputs['currency-price'] = this.reverseCurrencyPrice 
																		? inputs['currency-debit'] / inputs['debit'] 
																		: inputs['debit'] / inputs['currency-debit'] ;
							}else {
								return 0;
							}
						} else {
							if (!inputs['currency-credit']) {
								const newVal = (inputs['currency-debit'] 
									? inputs.debit / inputs['currency-debit']
									: 0);
								
								this.tableInputs['currency-price'] = this.reverseCurrencyPrice 
																			? (newVal 
																				? 1 / (newVal) 
																				: inputs['currency-price'] 
																					? 1 / inputs['currency-price'] 
																					: 0
																			) 
																			: newVal || inputs['currency-price'];
								if(this.reverseCurrencyPrice && inputs['currency-price']) {

									this.tableInputs.debit = (1 / inputs['currency-price']) *  inputs['currency-debit']

								} else {
										this.tableInputs.debit =
											inputs['currency-price']* inputs['currency-debit'];
								}
							}
						}
						return inputs['currency-debit'];
					}
				},
				{
					text: this.$t('AccountingJournalPage.headers.currency-credit'),
					name: 'currency-credit',
					value: 'currency_credit.amount',
					type: 'number-format',
					// width: this.$emerald.ifLang('es', '15%', '6%'),
					width: this.$emerald.ifLang('es', '15%', '7%'),
					inputRules: (() => {
						if (this.inputsValidations['currency-credit']) return [];
						else return [() => false]
					})(),
					setInputExpr: (inputs, activeInput) => {
						let price = this.reverseCurrencyPrice
										? (inputs['currency-price']? 1 / (inputs['currency-price']) : 0) 
										: inputs['currency-price'];
						if (activeInput !== 'currency-credit') {
							if (inputs.currency > 0 && inputs.credit && price) {
								this.tableInputs['currency-credit'] = inputs.credit / (price);
							} 
							else if (inputs['currency-credit'] && inputs['credit']) {
								this.tableInputs['currency-price'] = this.reverseCurrencyPrice 
																		? inputs['currency-credit'] / inputs['credit'] 
																		: inputs['credit'] / inputs['currency-credit'] ;
							}
							else {
								return 0;
							}
						} else {
							if (!inputs['currency-debit']) {
								const newVal = inputs['currency-credit'] 
									? inputs.credit / inputs['currency-credit']
									: 0;
								this.tableInputs['currency-price'] = this.reverseCurrencyPrice 
																			? (newVal 
																				? 1 / (newVal) 
																				: inputs['currency-price'] 
																					? 1 / inputs['currency-price'] 
																					: 0
																			) 
																			: newVal || inputs['currency-price'];
								if(this.reverseCurrencyPrice && inputs['currency-price']) {

									this.tableInputs.credit = (1 / inputs['currency-price']) *  inputs['currency-credit']
									
								} else {
										this.tableInputs.credit =
											inputs['currency-price']* inputs['currency-credit'];
								}
							}
						}
						return inputs['currency-credit'];
					}
				},
				{
					text: this.$t('AccountingJournalPage.headers.price'),
					name: 'currency-price',
					value: 'currency_price',
					width: '8%',
					type: 'number',
					settings: { itemText: 'equivalentPrice', context: 'entry', actionName: this.actions.GET },
					inputRules: (() => {
						if (this.inputsValidations['currency-price']) return [];
						else return [() => false];
					})(),
					// setValueExpr: (value, index) => {
					// 	if(this.reverseDivider) {
					// 		if(this.entries[index].credit && this.entries[index].currency_credit) {
					// 			value = this.entries[index].currency_credit.amount / this.entries[index].credit.amount
					// 		}
					// 		if(this.entries[index].debit && this.entries[index].currency_debit) {
					// 			value = this.entries[index].currency_debit.amount / this.entries[index].debit.amount
					// 		}
					// 	}
					// 	return value
					// },
					setValueExpr: v => this.reverseCurrencyPrice && v > 0? (1 / v) : v,
					setInputExpr: (inputs, activeInput) => {
						if (activeInput === 'currency-price') {
							const price = this.reverseCurrencyPrice
									? 1 / (inputs['currency-price'] || 1) 
									: inputs['currency-price'];
							if (inputs.currency > 0) {
								if (inputs.debit && inputs['currency-debit']) {
									this.tableInputs.debit = price * inputs['currency-debit'];
								} else if (inputs.credit && inputs['currency-credit']) {
									this.tableInputs.credit = price * inputs['currency-credit'];
								}
							}
						}
						return inputs['currency-price'];
					}
				},
				{
					text: this.$t('AccountingJournalPage.headers.paper-document-no'),
					name: 'paper-document-no',
					value: 'paper_document_no',
					width: '5%',
				},
				this.showDateEntryColumn ? {
					text: this.$t('AccountingJournalPage.headers.date'),
					name: 'date',
					value: 'date',
					type: 'date',
					// FIXME after replacing `bee-date-field` with `bee-date-input` you need format to be "DD-MM-YYYY"
					dateFormat: 'YYYY-MM-DD',
					// 	width: 170,
					width: 100,
					inputRules: [this.rules.required]
				} : null,
				{
					text: '',
					name: 'hint',
					value: 'hint',
					width: 30,
					noNotAvailableText: true,
					divider: false,
					noInput: true, 
				},
			];
			headers = headers.filter(v => Boolean(v));
			const commonClass = 'font-weight-bold px-2 grey--text text--darken-4';
			for (let i = 0; i < headers.length; i++) {
				headers[i].columnClass =
					headers[i].columnClass ? headers[i] + ' ' + commonClass : commonClass;
				headers[i].align = 'center';
			}

			return headers;
		},

		inputsValidations() {
			const inputs = this.tableInputs;
			return {
				debit: 
					(inputs['debit'] > 0 && !inputs['credit']) || (!inputs['debit'] && inputs['credit'] > 0),
				credit:
					(inputs['credit'] > 0 && !inputs['debit']) || (!inputs['credit'] && inputs['debit'] > 0),
				'currency-debit': 
					(!inputs['currency-debit'] && !inputs.currency) ||
					(inputs['currency-debit'] > 0 && inputs.currency > 0 && !inputs['credit']) ||
					(!inputs['currency-debit'] && inputs['currency-credit'] > 0 && inputs.currency > 0 && !inputs['debit']),
				'currency-credit': 
					(!inputs['currency-credit'] && !inputs.currency) ||
					(inputs['currency-credit'] > 0 && inputs.currency > 0 && !inputs['debit']) ||
					(!inputs['currency-credit'] && inputs['currency-debit'] > 0 && inputs.currency > 0 && !inputs['credit']),
				'currency-price':
					(!inputs.currency && !inputs['currency-price']) ||
					(inputs.currency && inputs['currency-price'])
			}
		},

		inputsValidationMessages() {
			const messages = [];
			const inputs = this.tableInputs;
			if (!inputs.debit && !inputs.credit) {
				messages.push(this.$t('table-messages.debit-and-credit-required'))
			}
			if (inputs.debit && inputs.credit) {
				messages.push(this.$t('table-messages.debit-and-credit-one-of'));
			}

			if (!inputs.account) {
				messages.push(this.$t('table-messages.account-required'));
			}
			
			if (!inputs.currency && (inputs['currency-debit'] || inputs['currency-credit'])) {
				messages.push(this.$t('table-messages.no-currency-debit-and-credit-without-currency'));
			}
			if (inputs.currency > 0 && !inputs['currency-debit'] && !inputs['currency-credit']) {
				messages.push(this.$t('table-messages.currency-debit-and-credit-required'));
			}
			if (inputs.debit && inputs['currency-credit']) {
				messages.push(this.$t('table-messages.debit-with-currency-debit-relation'));
			}
			if (inputs.credit && inputs['currency-debit']) {
				messages.push(this.$t('table-messages.credit-with-currency-credit-relation'));
			}

			if (inputs.currency > 0 && !inputs['currency-price']) {
				messages.push(this.$t('table-messages.currency-price-required'));
			}
			if (!inputs.currency && inputs['currency-price']) {
				messages.push(this.$t('table-messages.currency-required'));
			}

			// FIXME after replacing `bee-date-field` with `bee-date-input` you only need "!inputs.date" condition
			if ((!inputs.date || this.validationMessages.includes('invalid-input-date'))&& this.showDateEntryColumn) {
				messages.push(this.$t('table-messages.date-required'));
			}
			return messages
		},
		
		contextmenuItems(){
			const items = [
				this.userType !== this.userPermission.treasurer 
					? 	{
							title: this.$t('AccountingJournalPage.context-menu.account-statement'),
							event: 'account-statement',
							class: 'text-h6'
						} 
					: null
				,
				{
					title: this.$t('AccountingJournalPage.context-menu.edit'),
					event:'edit',
					disabled: this.bond.is_posted || this.file_is_locked,
					class: 'text-h6'
				},
				{
					title: this.$t('AccountingJournalPage.context-menu.delete'),
					event: 'delete',
					disabled: this.bond.is_posted || this.file_is_locked,
					class: 'text-h6'
				}
			]
			return items.filter(Boolean);
		},

		// bond
		bond() {
			return this.accountingBond;
		},
		entries: function() {
			return this.bond.entries || [];
		},

		file_is_locked() {
			return this.configs?.financial_file?.is_locked;
		},

		// bond posting progress circular
		bond_posting_ratio_tooltip() {
			return this.configs?.num_of_not_posted_bonds
				? `${this.configs.num_of_not_posted_bonds} ${this.$t('AccountingJournalPage.not-posted-bonds')}`
				: this.$t('AccountingJournalPage.all-bonds-are-posted');
		},
		bond_posting_ratio() {
			return this.configs?.num_of_total_bonds
				? 100 -
						(this.configs.num_of_not_posted_bonds * 100) /
							this.configs.num_of_total_bonds
				: 100;
		},
		bond_posting_ratio_caption() {
			return `${this.configs?.num_of_not_posted_bonds}/${this.configs?.num_of_total_bonds}`;
		},

		// footer
		sum_debits() {
			return this.bond?.statement_summary?.sum_result?.sum_debits || null;
		},
		sum_credits() {
			return this.bond?.statement_summary?.sum_result?.sum_credits || null;
		},
		sum_difference() {
			return this.bond?.statement_summary?.sum_result?.sum_difference || null;
		},
		sum_difference_equivalent_api() {
			return (
				this.bond?.statement_summary?.sum_result?.sum_difference_equivalent ||
				null
			);
		},

		currency_debits() {
			return (
				this.bond?.statement_summary?.sum_currencies_result?.currency_debits ||
				null
			);
		},
		currency_credits() {
			return (
				this.bond?.statement_summary?.sum_currencies_result?.currency_credits ||
				null
			);
		},
		currencies_sum_difference() {
			return (
				this.bond?.statement_summary?.sum_currencies_result?.currencies_sum_difference || 
				null
			)
		},
		create_bonds_manually() {
			return ls.getAskBeforeBondCreation();
		},
		show_symbol_currencies() {
			return ls.getVisibleSymbolMoney();
		},

		// helpers
		on_lgAndUp() {
			if (this.$vuetify.breakpoint.lgAndUp) return true;
			return false;
		},
		on_mdAndUp() {
			if (this.$vuetify.breakpoint.mdAndUp) return true;
			return false;
		},

		...mapState({
			simplified_bonds: state => state.bonds.simplified_accounting_bonds,
			configs: state => state.configs.configs,
			currentFinancialFile: state => state.financialFiles.current_financial_file,
			not_posted_bonds: state => state.bonds.not_posted_bonds,
			/*Avoid sharing bond store data when starting a new financial file, if it hasn't had cash bonds yet.*/
			accountingBond: state => state.bonds.bond,
			canUnPost: state => state.permissions.selfPermissions.canUnPost,
			users: state => state.users.users,
			userType: state => state.permissions.user_type,
		}),

		...mapGetters({
			getAccountById: 'configs/getAccountById',
			getCurrencyById: 'configs/getCurrencyById',
			isViewer: 'permissions/isViewer',
			getUserById: 'users/getUserById',
			getSettingByKey: 'settings/getSettingByKey',
		}),

		activeJournals() {
			return this.$route.query.type ? +this.$route.query.type : null;
		},

		filterJournals() {
			if (this.activeJournals === 1) {
				return this.simplified_bonds.filter(c => c.invoice_id) 
			} else if (this.activeJournals === 2) {
				return this.simplified_bonds.filter(c => !c.invoice_id)
			}
			return this.simplified_bonds
		},

		infoHeaders() {
			const headers = [
				{
					text: this.$t('invoice-headers.action'),
					value: 'type',
					name: 'type',
					sortable: false
				},
				{
					text: this.$t('invoice-headers.date-formatted'),
					value: 'date_formatted',
					name: 'date',
					sortable: false
				},
				{
					text: this.$t('invoice-headers.user'),
					value: 'user_id',
					setValueExpr: value => this.getUserById(value)?.user_name,
					name: 'userName',
					sortable: false
				}
			]
			return headers
		},
		showDateEntryColumn() {
			return this.getSettingByKey('ShowDateEntry')?.setting_value;
		},
		canAddFutureDate() {
			return this.getSettingByKey('CanAddFutureDate')?.setting_value;
		},
		defaultReversedCurrencyPrice() {
			return this.getSettingByKey('ReverseCurrencyPrice')?.setting_value;
		},
		advancedColorMode() {
			return this.getSettingByKey('ProfessionalAccountingColorMode')?.setting_value;
		},
		hideDeleteButton() {
			return this.getSettingByKey('hideDeleteBondButton')?.setting_value;
		}
	},


	methods: {
		// reverseDividerMethod() {
		// 	this.reverseDivider = !this.reverseDivider 

		// 	if (this.reverseDivider) {
		// 		this.tableInputs['currency-price'] = this.tableInputs['currency-debit'] / this.tableInputs.debit || this.tableInputs['currency-credit'] / this.tableInputs.credit
		// 	} else if (!this.reverseDivider){
		// 		this.tableInputs['currency-price'] =  this.tableInputs.debit / this.tableInputs['currency-debit'] ||  this.tableInputs.credit / this.tableInputs['currency-credit']
		// 	} else {
		// 		this.tableInputs['currency-price'] = ''
		// 	}
		// },
		reverseCurrency(value = this.reverseCurrencyPrice) {
			this.reverseCurrencyPrice = value;
			if(this.tableInputs['currency-price']) {
				this.tableInputs['currency-price'] = 1 / this.tableInputs['currency-price'];
			}
		},
		reverseCurrencyPriceInputValue() {
			if(this.tableInputs['currency-price'] && this.reverseCurrencyPrice) {
				this.tableInputs['currency-price'] = 1 / this.tableInputs['currency-price'];
			}
		},
		inputsNavigationHandler (e, headerName) {
			if (e.shiftKey) return;

			if (headerName === 'debit' && this.tableInputs.debit) {
				e.preventDefault();
				this.$refs.table.focus('account');
			}
			else if (headerName === 'currency' && this.tableInputs.credit) {
				e.preventDefault();
				this.$refs.table.focus('currency-credit');
			}
			else if (headerName === 'currency-debit' && this.tableInputs['currency-debit']) {
				e.preventDefault();
				this.$refs.table.focus('currency-price');
			}
		},

		entryHandler() {
			if (this.$refs.table.validate()) {
				this.loading = true;

				const actionName = !this.entryId ? 'createEntry' : 'updateEntry' ;
				this.$store.dispatch(`bonds/${actionName}`, {
					bondId: this.bond.id,
					bondType: bondType.accounting,
					entry: {
						id: this.entryId,
						account_id: this.tableInputs.account,
						bond_id: this.bond.id,
						debit: this.tableInputs.debit ? {
							amount: this.tableInputs.debit,
							currency_id: this.currentFinancialFile.default_currency_id
						} : null,
						credit: this.tableInputs.credit ? {
							amount: this.tableInputs.credit,
							currency_id: this.currentFinancialFile.default_currency_id
						} : null,
						currency_debit: this.tableInputs['currency-debit'] ? {
							amount: this.tableInputs['currency-debit'],
							currency_id: this.tableInputs.currency
						} : null,
						currency_credit: this.tableInputs['currency-credit'] ? {
							amount: this.tableInputs['currency-credit'],
							currency_id: this.tableInputs.currency
						} : null,
						currency_price: this.reverseCurrencyPrice && this.tableInputs['currency-price']
							? 1 / this.tableInputs['currency-price'] 
							:this.tableInputs['currency-price'],
						date: this.showDateEntryColumn ? this.tableInputs.date : this.bondData.date,
						note: this.tableInputs.note,
						// date: this.tableInputs.date.slice(0, 10),
						paper_document_no: this.tableInputs['paper-document-no'],
					}
				}).then(() => {
					this.fetchBond(true).then(() => {
						const initTable = () => {
							const savedNotes = this.saveNotes;
							this.$nextTick(() => {
								this.$refs.table.scrollToRow();
								this.$refs.table.scrollToRow();
								setTimeout(() => {
									this.$refs.table.resetInputs({
										// FIXME replace `bee-date-field` with `bee-date-input`
										// date:
										// 	this.entries.length
										// 		? this.entries[this.entries.length - 1].date.slice(0, 10)
										// 		: this.tableInputs.date.slice(0, 10),
										note: savedNotes,
										date: this.bondData.date
									});
									this.$refs.table.resetInputsFocus();
									
								})
							})
						}
						
						if (this.entryId) {
							this.entryId = null;
							this.saveNotes = this.tableInputs.note;
							const nextRowIndex = this.$refs.table.editNextRow();
							if (nextRowIndex !== -1) {
								this.entryId = this.entries[nextRowIndex].id;
								this.reverseCurrencyPriceInputValue();
								this.$nextTick(() => {
									this.$refs.table.scrollToRow();
									setTimeout(() => {
										this.$refs.table.resetInputsFocus();
									})
								})

							} else {
								initTable();
							}
						} else {
							initTable();
						}
						
					});
				}).finally(() => {
					this.loading = false;
				})
			}
		},
		fetchEntry(id) {
			this.loading = true;
			if (id) {
				store.dispatch('bonds/fetchEntry', { id });
			}
		},
		confirmDeleteEntry() {
			this.loading = true;
			store.dispatch("bonds/deleteEntry", {
				bondId: this.bond.id,
				bondType: bondType.accounting,
				entryId: this.deleteEntryId
			})
			.then(() => {
				this.deleteEntryId = null;
				this.fetchBond(true);
			})
			this.$refs.table.resetEdit();
		},

		addBond() {
			if(this.valid) {
				this.loading = true;
				// this.simplified_bond.date = this.bond_date
				store.dispatch("bonds/create", {
					bondType: bondType.accounting,
					date: this.bond_date,
					notes: this.bond_notes
				})
				.then(() => {
					this.bond_no = this.bond.bond_no;
					this.$router.push({ name: "accounting-journal", params: { id: this.bond.id } })
					// this.$refs.table.endLineInputValues = {	date: new Date().toISOString() };
					// this.$refs.table.onEsc();
					store.dispatch("configs/fetchAll")
					this.$store.dispatch("bonds/fetch", {
						bondId: this.$route.params.id,
						bondType: bondType.accounting
					}).then(response => {
						this.bondData.date = response.date;
						this.bondData.notes = response.notes;
						this.$refs.table.resetInputs({
							/*important to keep the date input has value */
							date: this.bondData.date
						});
					})
				})
				.finally(() => (this.loading = false));

				this.addBondDialog = false;
				this.bond_date = moment().format('YYYY-MM-DD');
			}
		},
		updateBond() {
		/*temporary solved until find a solution to date picker validation*/
			if(moment(this.bondData.date).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD') || this.canAddFutureDate) {
				if(this.$refs.dateEdit) {
				this.$store.dispatch('bonds/update', {
					bondId: this.bond.id,
					bondType: this.bondData.type,
					date: this.bondData.date,
					notes: this.bondData.notes
				})
				.then(() => {
					this.fetchBond(true);
					EventBus.$emit("notification", "تم تحديث بيانات السند");
				})
			}
			}
		},
		/* eslint-disable */
		fetchBond(isUpdate = false) {
			var bond = this.simplified_bonds?.find(c => c.bond_no == this.bond_no);
			if (bond && (bond.id != Number(this.$route.params.id) || isUpdate)) {
				!isUpdate ? this.$router.push({ name: "accounting-journal", params: { id: bond.id }, query: this.$route.query }):null
				this.loading = true;
					return store.dispatch("bonds/fetch", {
						bondId: Number(this.$route.params.id),
						bondType: bondType.accounting
					})
					.then(response => {
						this.bondData.date = response.date;
						this.bondData.notes = response.notes;
						if (!isUpdate) {
							this.$refs.table.resetEdit();
							this.$nextTick(() => {
								this.$refs.table.scrollToRow();
								this.$refs.table.scrollToRow();
								if(!response.is_posted) {
									setTimeout(() => {
										this.$refs.table.resetInputs({
											/*important to keep the date input has value */
											date: this.bondData.date,
											note: response.entries[response.entries.length? response.entries.length - 1 : 0].note
										});
										this.$refs.table.resetInputsFocus();
									})
								}
							});
						}
						this.loading = false;
					});
			} else{
				this.bondData.date = bond.date
				this.bondData.notes = bond.notes;
			}
		},

		fetchBondByNo(bondNo) {
			if (bondNo) {
				this.loading = true;
				store.dispatch("bonds/fetchBondByNumber", {
					bondType: bondType.accounting,
					bondNo: bondNo
				})
				.then(() => {
					this.loading = false;
				});
			}
		},
		DeleteBond(){
			this.deleteLoading = true

			store.dispatch("bonds/delete", {
				bondId: this.bond.id,
				bondType: this.bond.type ? bondType.cash : bondType.accounting
			}).then(() => {
				let promises = [ 
					store.dispatch("configs/fetchAll"),
					store.dispatch("bonds/search", { bondId: this.bondId, type: this.type, status: this.status, fromDate: this.fromDate, toDate: this.toDate, dateSortMode: 2, bondTypeSortMode: 2 }),
					store.dispatch("bonds/fetchAll", { bondType: bondType.accounting }).then(() => {
						this.$router.push({
								name:'accounting-journal',
								params:
									this.simplified_bonds.length
										? { id: this.simplified_bonds[this.simplified_bonds.length - 1].id }
										: {}
							})
					}),
					store.dispatch("bonds/fetchAll", { bondType: bondType.cash })
				]
				Promise.all(promises)
			}).finally(() => {this.deleteLoading = false ;});	
        },
		/* eslint-disable */
		posting() {
			// this.entryHandler()
			this.updateBondLoading = true;
			this.loading = true;
			store.dispatch("bonds/updateToPosted", {
				bondId: this.bond.id,
				bondType: bondType.accounting
			})
			.then(() => {
				this.$refs.table.resetEdit();
				Promise.all([
					store.dispatch("configs/fetchAll"),
					store.dispatch("bonds/fetch", {
						bondId: this.bond.id,
						bondType: bondType.accounting
					})
				]).finally(() => {
					this.updateBondLoading = false;
					this.loading = false	;
				});
			}).catch(() => { this.updateBondLoading = false;this.loading = false })
		},
		unPosting() {
			this.loading = true;
			this.updateBondLoading = true;
			store.dispatch("bonds/updateToNonPosted", {
				bondId: this.bond.id,
				bondType: bondType.accounting
			})
			.then(() => {
				Promise.all([
					store.dispatch("configs/fetchAll"),
					store.dispatch("bonds/fetch", {
						bondId: this.bond.id,
						bondType: bondType.accounting
					})
				]).finally(() => {
					this.updateBondLoading = false;
					this.loading = false;
					this.tableInputs.note = this.bond.entries[this.bond.entries.length ? this.bond.entries.length - 1 : 0].note
				});;
			}).catch(() => { this.updateBondLoading = false; this.loading = false })
		},
		changeSumDifferenceEquivalent(toCurrencyId) {
			if (toCurrencyId) {
				if (this.sum_difference?.amount) {
					let amount = this.sum_difference.amount;
					let fromCurrecyId = this.sum_difference.currency_id;
					store.dispatch("currencies/exchangeToCurrency", {
						toCurrencyId,
						amount,
						fromCurrecyId
					})
					.then(response => {
						_.set(this.sum_difference_equivalent, "amount", response.amount);
						_.set(
							this.sum_difference_equivalent,
							"currency_id",
							response.currency_id
						);
						_.set(
							this.sum_difference_equivalent,
							"money_type",
							this.sum_difference_equivalent_api?.money_type
						);
					});
				}
			}
		},
		async createAccount() {
			this.showAccountForm = true;
			await store.dispatch("customStatements/fetchAll");
		},
		reForwardToRelatedInvoice() {
			store
				.dispatch("invoices/fetchInvoiceType", {
					invoiceId: this.bond.invoice_id
				})
				.then(response => {
					if (response == "Buy")
						this.$router.push({
							name: "invoices-buy",
							params: { id: this.bond.invoice_id },
							query: {
								withCategory: true
							}
						});
					else if (response == "Sale")
						this.$router.push({
							name: "invoices-sale",
							params: { id: this.bond.invoice_id },
							query: {
								withCategory: true
							}
						});
					else if(response == 'BuyRefund')
						this.$router.push({
							name:'buy-invoice-refund',
							params: {id: this.bond.invoice_id},
							query: {
								withCategory: true
							}
						})
					else if (response == 'SaleRefund')
						this.$router.push({
							name:'sale-invoice-refund',
							params: {id:this.bond.invoice_id},
							query: {
								withCategory: true
							}
						})
				});
		},

		openAccountStatement({ item }) {
			if (openNewWindowForAccountStatement) {
				window.open(this.$router.resolve({ name: 'statement', params: { id: item.account_id } }).href, '_blank');
			} else {
				const route = this.$router.resolve({ 
					name: 'statement', 
					params: { id: item.account_id }
				});
				window.open(route.href, '_blank');
			}
		}
	},

	mounted() {
		this.loading = false;
		// this.$nextTick(() => {
		// 	this.$refs.table.resetInputs({
		// 		date: moment().format('YYYY-MM-DD')
		// 	})
		// })
		this.reverseCurrencyPrice = this.defaultReversedCurrencyPrice;
		window.observer.observe(document.querySelector("#footer"));
		
		!this.users.length ? this.$store.dispatch('users/fetchAll') : null
	},
	beforeDestroy() {
	this.$store.dispatch('bonds/clearBond')
	},
	async beforeRouteEnter(to, from, next) {
		let promises = [];

		let bonds = store.state.bonds.simplified_accounting_bonds;
		if (bonds.length == 0){
			promises.push(store.dispatch("bonds/fetchAll", { bondType: bondType.accounting }));
		}

		if (promises.length) { await Promise.all(promises) };

		if (to.params.id) {
			if (to.name != "accounting-journal"){
				next({
					name: "accounting-journal",
					params: { id: to.params.id },
					replace: true,
				});
			}
		} else {
			bonds = store.state.bonds.simplified_accounting_bonds;
			/* if (this.activeJournals === 1) {
				return this.simplified_bonds.filter(c => c.invoice_id !== null)
			} else if (this.activeJournals === 2) {
				return this.simplified_bonds.filter(c => c.invoice_id === null)
			} */
			if (bonds.length > 0){
				next({
					name: "accounting-journal",
					params: { id: bonds[bonds.length - 1].id },
					replace: true,
				})
			};
		}
		next(vm => {
			if (to.name == "accounting-journal") {
				if (to.params.id) {
					vm.loading = true;
					store.dispatch("bonds/fetch", {
						bondId: Number(to.params.id),
						bondType: bondType.accounting
					})
					.then(response => {
						vm.loading = false;
						vm.bond_no = response.bond_no;
						vm.bondData.date = response.date;
						vm.bondData.notes = response.notes;
						vm.tableInputs.date = response.date;
						vm.tableInputs.note = response.entries[response.entries.length? response.entries.length - 1 : 0].note;
					});
				}  
			}
		});
	},

};
</script>

<style scoped>
/* first part of the footer */
.custom_debit_credit_styles{
	width: 120px;
	height: 30px;
}
.custom_sum_difference_styles{
	width: 240px;
	height: 30px;
}

/* second part of the footer */
.custom_currency_debits_credits_styles{
	width: 140px;
	height: 68px;
}
.custom_currency_sum_styles{
	width: 155px;
	height: 68px;
	margin-left: 10px;
}

/*===============*/
/* media queries */
/*===============*/
@media (max-width: 1368px) {
	/* first part of the footer */
	.custom_debit_credit_styles{
		width: 103px;
	}
	.custom_sum_difference_styles{
		width: 206px;
	}

	/* second part of the footer */
	.custom_currency_debits_credits_styles{
		width: 124px;
	}
	.custom_currency_sum_styles{ 
		margin-left: 0;
	}
}


.medium-placeholder .v-label {
	font-size: 0.7rem !important;
}
.my-border {
	border: 1px solid !important;
	border-color: #f1f1f1 !important;
}
</style>
<style>
.journal .v-expansion-panel-content__wrap {
	padding: 0px !important;
	flex: 1 1 auto;
	max-width: 100%;
}
/* .v-toolbar__content {
	padding-left: 0px !important;
} */
</style>